import {Form} from '../../../../../stores/Form';

export const isCurrentRecordEmpty = (currentForm: Form | null) => {
    const currentRecord = currentForm?.records[currentForm?.currentRow];

    return currentRecord ? currentRecord.isEmpty() : true;
};
